/* eslint-disable */
import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import {
    IconButton, TextField, Typography, Popover, Tooltip, Grid
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridFooterContainer,
    GridFooter
} from '@mui/x-data-grid';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import fileDownload from 'js-file-download';
import dayjs from 'dayjs';
import { actions as documentActions } from '../documents/sagaSlice';
import { scopeValidator } from '#/permissions';
import { api } from '#/apis';
//import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import {
    Button
} from 'semantic-ui-react';

import { useProperty } from '~/properties';
import { useDelinquencies } from '~/entrataReports';
import { useBuildingOccupancy } from '~/entrataReports';

import { selectModal } from './utils';
import DelinquencyLegend from './DelinquencyLegend';
import ColorLegend from './ColorLegend';
import DelinquencyPopoverContent from './DelinquencyPopoverContent';
import { PrintDocument } from './PrintDocument';

const useStyles = makeStyles({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '10px',
        alignItems: 'center'
    },
    cellColumn: { flexDirection: 'column' },
    tooltip: {
        fontSize: '1em',
        zIndex: 10000
    },
    renderedCell: { lineHeight: 'normal !important' },
    autocomplete: { lineHeight: '70px !important' },
    yellow: { backgroundColor: '#ffd599' },
    purple: { backgroundColor: '#d983e4' },
    green: { backgroundColor: '#b7dfb9' },
    blue: { backgroundColor: '#B7D5F4' },
    red: { backgroundColor: '#fab3ae' },
    white: { backgroundColor: '#FFF' },
    grey: { backgroundColor: '#9e9e9ebf' },
    lightGreen: { backgroundColor: '#88e27cbf' },
    lightBlue: { backgroundColor: '#a5eff1bf' },
    orange: { backgroundColor: '#e4b152bf' },
    padded: { padding: '1em' },
    legendContainer: {
        //the view width, minues the drawer width, minus default padding
        width: 'calc(100vw - 220px - 48px)',
        marginBottom: '10px'
    }

});

function CustomTooltip(props) {
    const classes = useStyles();

    return (
        <Tooltip placement='bottom' classes={{ tooltip: classes.tooltip }} title={props.value || 'N/A'}>
            <div>
                {props.value}
            </div>
        </Tooltip>
    );
}

const ViewDelinquencies = props => {

    const {
        fetchDocuments,
        documents,
        user_id,
        match
    } = props;


    const { property_id } = match.params;

    //const { ref, Trigger } = usePrint({}, true);
    const classes = useStyles();
    const { data: property } = useProperty(property_id);
    const { data: delinquencies, isLoading } = useDelinquencies(property_id);
    const { data: dataBuildingOccupancy, isLoading: isLoadingBuildingOccupancy } = useBuildingOccupancy(property_id);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [popoverText, setPopoverText] = React.useState(null);
    const [shouldPrint, setShouldPrint] = React.useState(false);

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };


    const open = Boolean(anchorEl);

    const adminOrLegal = scopeValidator(props.role, ['legal', 'legal_admin']);

    const handleDownload = async (doc, payload) => {
        const _payload = {
            ...payload,
            ...payload.data,
            property_id,
            user_id
        };

        delete _payload.data;

        if (doc.requires_notary) {
            const notary = await selectModal('/notaries/stamps', 'Notary');
            if (!notary) return;
            _payload.notary_name = notary.name;
            _payload.notary_commission_number = notary.commission_number;
            _payload.notary_commission_expiration = notary.commission_expiration;
        }

        if (doc.requires_lawyer) {
            const lawyer = await selectModal('/lawyers', 'Lawyer');
            if (!lawyer) return;
            _payload.lawyer_name = lawyer.name;
            _payload.lawyer_address = lawyer.address;
            _payload.lawyer_phone_number = lawyer.phone_number;
            _payload.lawyer_bar_number = lawyer.bar_number;
        }

        const url = `/documents/${doc.name}/generate`;
        const opts = { responseType: 'blob' };

        const { data } = await api.post(url, _payload, opts);
        fileDownload(data, doc.name);
    };

    useEffect(fetchDocuments, [fetchDocuments]);

    function CustomToolbar() {

        let PrintButton = (
            <Button

                style={{
                    color: '#002144',
                    backgroundColor: '#fafafa',
                    fontSize: '12px',
                    fontFamily: 'Lato',
                    padding: 5,
                    fontWeight: 100
                }} onClick={() => setShouldPrint(true)}>
                Prepare to Print
            </Button>
        );

        if (shouldPrint) {

            PrintButton = (
                <PrintDocument
                    data={delinquencies}
                    propertyName={property.name}
                    dataBuildingOccupancy={dataBuildingOccupancy}
                    totalDelinquentForProperty={totalDelinquentForProperty}
                    totalDelinquentForExictions={totalDelinquentForExictions}
                    counts={counts}
                    adminOrLegal={adminOrLegal}
                />
            );
        }

        return (
            <GridToolbarContainer className='hide'>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />
                <LocalPrintshopIcon sx={{ color: '#002144' }}/>

                { PrintButton }

            </GridToolbarContainer>
        );
    }

    const setWidth = () => {

    }

    const columns = useMemo(() => {
        if (
            [
            "Inverrary 441 Apartments",
            "2500 Inverrary Club Apartments, LLC",
            "Sunshine Lakes Apartments",
            "Cypress Place Apartments",
            "Pompano Palms Apartments",
            "Suncoast Place Apartments",
            "Colony at Dadeland Apartments",
            "Las Brisas Gardens Apartments"
         ].includes(property?.name)
         ) {
            return [
             {
                    renderHeader: () => <div/>,
                    field: 'id',
                    align: 'center',
                    alignHeader: 'center',
                    renderCell: ({ row }) => (
                        <IconButton onClick={() => props.history.push(`/reports/${property_id}/delinquencies/${row.id}`)}>
                            <EditIcon />
                        </IconButton>
                    ),
                    width: 80,
                    disableExport: true,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Documents</strong>,
                    field: 'documents',
                    align: 'center',
                    alignHeader: 'center',
                    cellClassName: `${classes.autocomplete} hide`,
                    headerClassName: 'hide',
                    renderCell: ({ row }) => (
                        <Autocomplete
                            clearOnBlur
                            disableClearable
                            options={documents || []}
                            getOptionLabel={option => option.description || option.name}
                            renderInput={params => <TextField margin='dense' {...params} InputProps={{
                                ...params.InputProps,
                                disableUnderline: true
                            }} fullWidth label='Generate Document' />}
                            fullWidth
                            onChange={(e, doc) => handleDownload(doc, row)}
                        />
                    ),
                    width: 200,
                    disableExport: true,
                    hide: !adminOrLegal
                },
                {
                    renderHeader: () => <strong>Unit #</strong>,
                    field: 'bldg_unit',
                    width: 150
                },
                {
                    renderHeader: () => <strong>Resident Name</strong>,
                    field: 'resident_name',
                    cellClassName: classes.stickyCell,
                    width: 250
                },
                {
                    renderHeader: () => <strong>Lease Status</strong>,
                    field: 'lease_status',
                    cellClassName: classes.renderedCell,
                    renderCell: ({ row }) => (
                        <div>
                            {row.lease_status}
                            {(row.data.special_status || row.lease_sub_status) && < hr /> }
                            {row.data.special_status && <div>Special-status: {row.data.special_status}</div>}
                            {row.lease_sub_status && <div>Sub-status: <div>{row.lease_sub_status} </div> </div>}
                        </div>
                    ),
                    width: 190
                },
                {
                    renderHeader: () => <strong>Total Delinquent</strong>,
                    field: 'total_delinquent',
                    cellClassName: classes.renderedCell,
                    renderCell: ({ row }) => (
                        <div>
                            Current due: <strong>${row.total_current_due}</strong>
                            <div>Past due: <strong>${row.total_past_due}</strong></div>
                            <div>Total del: <strong>${row.total_delinquent.toFixed(2)}</strong></div>
                        </div>
                    ),
                    width: 170
                },
                {
                    renderHeader: () => <strong>Sec8 Delinquent</strong>,
                    field: 'total_delinquent_sec8',
                    cellClassName: classes.renderedCell,
                    renderCell: ({ row }) => (
                        <div>
                            Current due: <strong>${row.total_current_due_sec8}</strong>
                            <div>Past due: <strong>${row.total_past_due_sec8}</strong></div>
                            <div>Total del: <strong>${row.total_delinquent_sec8.toFixed(2)}</strong></div>
                        </div>
                    ),
                    width: 170
                },
                {
                    renderHeader: () => <strong>Manager Notes</strong>,
                    field: 'data.manager_notes',
                    valueFormatter: ({ row }) => row.data?.manager_notes,
                    renderCell: ({ row }) => <TextField
                        multiline
                        rows={3}
                        defaultValue={row.data?.manager_notes}
                        variant='standard'
                        fullWidth={true}
                        InputProps={{
                            disableUnderline: true
                        }}
                    />,
                    width: 250,
                    disableExport: false
                },
                {
                    renderHeader: () => <strong>Scheduled Rent</strong>,
                    field: 'scheduled_rent',
                    cellClassName: classes.renderedCell,
                    renderCell: ({ row }) => {
                        const rent = Number(row.scheduled_rent) + Number(row.other_scheduled_rent || 0);
        
                        return (
                            <div>
                                ${rent.toFixed(2)}
                            </div>
                        );
                    },
                    width: 170
                },
                {
                    renderHeader: () => <strong>Hold Date</strong>,
                    field: 'data.hold_date',
                    type: 'date',
                    valueFormatter: ({ row }) => formatDate(row.data?.hold_date),
                    // align: 'center',
                    // alignHeader: 'center',
                    width: 120,
                    disableExport: false
                },
                {
                    renderHeader: () => <strong>Held By</strong>,
                    field: 'data.held_by',
                    valueFormatter: ({ row }) => row.data?.held_by,
                    width: 100,
                    disableExport: false
                },
                {
                    renderHeader: () => <strong>Admin Notes</strong>,
                    valueFormatter: ({ row }) => row.data?.admin_notes,
                    renderCell: ({ row }) => <TextField
                        multiline
                        rows={3}
                        defaultValue={row.data?.admin_notes}
                        variant='standard'
                        fullWidth={true}
                        InputProps={{
                            disableUnderline: true
                        }}
                    />,
                    field: 'data.admin_notes',
                    width: 250,
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
                },
                {
                    field: 'data.general_notes',
                    renderHeader: () => <strong>General Notes</strong>,
                    valueFormatter: ({ row }) => row.data?.general_notes,
                    renderCell: ({ row }) => <TextField
                        multiline
                        rows={3}
                        defaultValue={row.data?.general_notes}
                        variant='standard'
                        fullWidth={true}
                        InputProps={{
                            disableUnderline: true
                        }}
                    />,
                    width: 200,
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
                },
                {
                    field: 'data.court_registry',
                    renderHeader: () => <strong>Court Registry</strong>,
                    valueFormatter: ({ row }) => row.data?.court_registry,
                    renderCell: ({ row }) => <CustomTooltip value={row.data?.court_registry} />,
                    width: 150,
                    disableExport: false,
                    hide: !adminOrLegal
                    //headerClassName: 'hide'
                    //cellClassName: 'hide'
                },
                {
                    renderHeader: () => <strong>3 Day Served</strong>,
                    field: 'data.three_day_served',
                    valueFormatter: ({ row }) => row.data?.three_day_served,
                    width: 150,
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
                },
                {
                    renderHeader: () => <strong>File Date</strong>,
                    field: 'data.file_date',
                    width: 110,
                    valueFormatter: ({ row }) => formatDate(row.data?.file_date),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
                },
                {
                    renderHeader: () => <strong>Case #</strong>,
                    field: 'data.case_number',
                    valueFormatter: ({ row }) => row.data?.case_number,
                    width: 150,
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
                },
                {
                    renderHeader: () => <strong>Summons Served</strong>,
                    field: 'data.summons_served',
                    width: 165,
                    valueFormatter: ({ row }) => formatDate(row.data?.summons_served),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Default Date</strong>,
                    field: 'data.default_date',
                    width: 135,
                    valueFormatter: ({ row }) => formatDate(row.data?.default_date),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Motion to Strike</strong>,
                    field: 'data.motion_to_strike',
                    width: 155,
                    valueFormatter: ({ row }) => formatDate(row.data?.motion_to_strike),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Judgement</strong>,
                    field: 'data.judgement',
                    width: 115,
                    valueFormatter: ({ row }) => formatDate(row.data?.judgement),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Writ of Possession</strong>,
                    field: 'data.writ_of_possession',
                    width: 165,
                    valueFormatter: ({ row }) => formatDate(row.data?.writ_of_possession),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>24 Hour Notice</strong>,
                    field: 'data.twentyfour_hour_notice',
                    width: 155,
                    valueFormatter: ({ row }) => formatDate(row.data?.twentyfour_hour_notice),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => (
                        <div>
                            <strong>Stipulation</strong>
                            <div>Initial Payment</div>
                        </div>
                    ),
                    field: 'data.initial_payment',
                    width: 200,
                    cellClassName: `${classes.renderedCell} hide`,
                    headerClassName: `${classes.renderedCell} hide`,
                    renderCell: ({ row }) => (row.data?.initial_payment ? `$${row.data.initial_payment}` : ''),
                    valueFormatter: ({ row }) => row.data?.initial_payment,
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
        
                },
                {
                    renderHeader: () => (
                        <div>
                            <strong>Stipulation</strong>
                            <div>Balance</div>
                        </div>
                    ),
                    field: 'data.balance',
                    width: 200,
                    valueFormatter: ({ row }) => row.data?.balance,
                    cellClassName: `${classes.renderedCell} hide`,
                    headerClassName: `${classes.renderedCell} hide`,
                    renderCell: ({ row }) => (row.data.balance ? `$${row.data.balance}` : ''),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
                },
                {
                    renderHeader: () => (
                        <div>
                            <strong>Stipulation</strong>
                            <div>Signed Date</div>
                        </div>
                    ),
                    field: 'data.stipulation_signed_date',
                    width: 150,
                    cellClassName: 'hide',
                    headerClassName: `${classes.renderedCell} hide`,
                    valueFormatter: ({ row }) => formatDate(row.data?.stipulation_signed_date),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
                },
                {
                    renderHeader: () => <strong>Special Status</strong>,
                    field: 'data.special_status',
                    width: 150,
                    valueFormatter: ({ row }) => row.data?.special_status,
                    disableExport: false,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Sub-Status</strong>,
                    field: 'lease_sub_status',
                    renderCell: ({ row }) => (row.data.lease_sub_status
                    ),
                    disableExport: false,
                    headerClassName: 'hide',
                    cellClassName: 'hide',
                    width: 200
                }
                // eslint-disable-next-line react-hooks/exhaustive-deps
            ]
        }
        else {
             return [
                {
                    renderHeader: () => <div/>,
                    field: 'id',
                    align: 'center',
                    alignHeader: 'center',
                    renderCell: ({ row }) => (
                        <IconButton onClick={() => props.history.push(`/reports/${property_id}/delinquencies/${row.id}`)}>
                            <EditIcon />
                        </IconButton>
                    ),
                    width: 80,
                    disableExport: true,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Documents</strong>,
                    field: 'documents',
                    align: 'center',
                    alignHeader: 'center',
                    cellClassName: `${classes.autocomplete} hide`,
                    headerClassName: 'hide',
                    renderCell: ({ row }) => (
                        <Autocomplete
                            clearOnBlur
                            disableClearable
                            options={documents || []}
                            getOptionLabel={option => option.description || option.name}
                            renderInput={params => <TextField margin='dense' {...params} InputProps={{
                                ...params.InputProps,
                                disableUnderline: true
                            }} fullWidth label='Generate Document' />}
                            fullWidth
                            onChange={(e, doc) => handleDownload(doc, row)}
                        />
                    ),
                    width: 200,
                    disableExport: true,
                    hide: !adminOrLegal
                },
                {
                    renderHeader: () => <strong>Unit #</strong>,
                    field: 'bldg_unit',
                    width: 150
                },
                {
                    renderHeader: () => <strong>Resident Name</strong>,
                    field: 'resident_name',
                    cellClassName: classes.stickyCell,
                    width: 250
                },
                {
                    renderHeader: () => <strong>Lease Status</strong>,
                    field: 'lease_status',
                    cellClassName: classes.renderedCell,
                    renderCell: ({ row }) => (
                        <div>
                            {row.lease_status}
                            {(row.data.special_status || row.lease_sub_status) && < hr /> }
                            {row.data.special_status && <div>Special-status: {row.data.special_status}</div>}
                            {row.lease_sub_status && <div>Sub-status: <div>{row.lease_sub_status} </div> </div>}
                        </div>
                    ),
                    width: 190
                },
                {
                    renderHeader: () => <strong>Total Delinquent</strong>,
                    field: 'total_delinquent',
                    cellClassName: classes.renderedCell,
                    renderCell: ({ row }) => (
                        <div>
                            Current due: <strong>${row.total_current_due}</strong>
                            <div>Past due: <strong>${row.total_past_due}</strong></div>
                            <div>Total del: <strong>${row.total_delinquent.toFixed(2)}</strong></div>
                        </div>
                    ),
                    width: 170
                },
                {
                    renderHeader: () => <strong>Manager Notes</strong>,
                    field: 'data.manager_notes',
                    valueFormatter: ({ row }) => row.data?.manager_notes,
                    renderCell: ({ row }) => <TextField
                        multiline
                        rows={3}
                        defaultValue={row.data?.manager_notes}
                        variant='standard'
                        fullWidth={true}
                        InputProps={{
                            disableUnderline: true
                        }}
                    />,
                    width: 250,
                    disableExport: false
                },
                {
                    renderHeader: () => <strong>Scheduled Rent</strong>,
                    field: 'scheduled_rent',
                    cellClassName: classes.renderedCell,
                    renderCell: ({ row }) => {
                        const rent = Number(row.scheduled_rent) + Number(row.other_scheduled_rent || 0);
        
                        return (
                            <div>
                                ${rent.toFixed(2)}
                            </div>
                        );
                    },
                    width: 170
                },
                {
                    renderHeader: () => <strong>Hold Date</strong>,
                    field: 'data.hold_date',
                    type: 'date',
                    valueFormatter: ({ row }) => formatDate(row.data?.hold_date),
                    // align: 'center',
                    // alignHeader: 'center',
                    width: 120,
                    disableExport: false
                },
                {
                    renderHeader: () => <strong>Held By</strong>,
                    field: 'data.held_by',
                    valueFormatter: ({ row }) => row.data?.held_by,
                    width: 100,
                    disableExport: false
                },
                {
                    renderHeader: () => <strong>Admin Notes</strong>,
                    valueFormatter: ({ row }) => row.data?.admin_notes,
                    renderCell: ({ row }) => <TextField
                        multiline
                        rows={3}
                        defaultValue={row.data?.admin_notes}
                        variant='standard'
                        fullWidth={true}
                        InputProps={{
                            disableUnderline: true
                        }}
                    />,
                    field: 'data.admin_notes',
                    width: 250,
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
                },
                {
                    field: 'data.general_notes',
                    renderHeader: () => <strong>General Notes</strong>,
                    valueFormatter: ({ row }) => row.data?.general_notes,
                    renderCell: ({ row }) => <TextField
                        multiline
                        rows={3}
                        defaultValue={row.data?.general_notes}
                        variant='standard'
                        fullWidth={true}
                        InputProps={{
                            disableUnderline: true
                        }}
                    />,
                    width: 200,
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
                },
                {
                    field: 'data.court_registry',
                    renderHeader: () => <strong>Court Registry</strong>,
                    valueFormatter: ({ row }) => row.data?.court_registry,
                    renderCell: ({ row }) => <CustomTooltip value={row.data?.court_registry} />,
                    width: 150,
                    disableExport: false,
                    hide: !adminOrLegal
                    //headerClassName: 'hide'
                    //cellClassName: 'hide'
                },
                {
                    renderHeader: () => <strong>3 Day Served</strong>,
                    field: 'data.three_day_served',
                    valueFormatter: ({ row }) => row.data?.three_day_served,
                    width: 150,
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
                },
                {
                    renderHeader: () => <strong>File Date</strong>,
                    field: 'data.file_date',
                    width: 110,
                    valueFormatter: ({ row }) => formatDate(row.data?.file_date),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
                },
                {
                    renderHeader: () => <strong>Case #</strong>,
                    field: 'data.case_number',
                    valueFormatter: ({ row }) => row.data?.case_number,
                    width: 150,
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
                },
                {
                    renderHeader: () => <strong>Summons Served</strong>,
                    field: 'data.summons_served',
                    width: 165,
                    valueFormatter: ({ row }) => formatDate(row.data?.summons_served),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Default Date</strong>,
                    field: 'data.default_date',
                    width: 135,
                    valueFormatter: ({ row }) => formatDate(row.data?.default_date),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
                    // headerClassName: 'hide',
                    // cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Motion to Strike</strong>,
                    field: 'data.motion_to_strike',
                    width: 155,
                    valueFormatter: ({ row }) => formatDate(row.data?.motion_to_strike),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Judgement</strong>,
                    field: 'data.judgement',
                    width: 115,
                    valueFormatter: ({ row }) => formatDate(row.data?.judgement),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Writ of Possession</strong>,
                    field: 'data.writ_of_possession',
                    width: 165,
                    valueFormatter: ({ row }) => formatDate(row.data?.writ_of_possession),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>24 Hour Notice</strong>,
                    field: 'data.twentyfour_hour_notice',
                    width: 155,
                    valueFormatter: ({ row }) => formatDate(row.data?.twentyfour_hour_notice),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => (
                        <div>
                            <strong>Stipulation</strong>
                            <div>Initial Payment</div>
                        </div>
                    ),
                    field: 'data.initial_payment',
                    width: 200,
                    cellClassName: `${classes.renderedCell} hide`,
                    headerClassName: `${classes.renderedCell} hide`,
                    renderCell: ({ row }) => (row.data?.initial_payment ? `$${row.data.initial_payment}` : ''),
                    valueFormatter: ({ row }) => row.data?.initial_payment,
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
        
                },
                {
                    renderHeader: () => (
                        <div>
                            <strong>Stipulation</strong>
                            <div>Balance</div>
                        </div>
                    ),
                    field: 'data.balance',
                    width: 200,
                    valueFormatter: ({ row }) => row.data?.balance,
                    cellClassName: `${classes.renderedCell} hide`,
                    headerClassName: `${classes.renderedCell} hide`,
                    renderCell: ({ row }) => (row.data.balance ? `$${row.data.balance}` : ''),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
                },
                {
                    renderHeader: () => (
                        <div>
                            <strong>Stipulation</strong>
                            <div>Signed Date</div>
                        </div>
                    ),
                    field: 'data.stipulation_signed_date',
                    width: 150,
                    cellClassName: 'hide',
                    headerClassName: `${classes.renderedCell} hide`,
                    valueFormatter: ({ row }) => formatDate(row.data?.stipulation_signed_date),
                    // align: 'center',
                    // alignHeader: 'center',
                    disableExport: false,
                    hide: !adminOrLegal
                },
                {
                    renderHeader: () => <strong>Special Status</strong>,
                    field: 'data.special_status',
                    width: 150,
                    valueFormatter: ({ row }) => row.data?.special_status,
                    disableExport: false,
                    headerClassName: 'hide',
                    cellClassName: 'hide'
        
                },
                {
                    renderHeader: () => <strong>Sub-Status</strong>,
                    field: 'lease_sub_status',
                    renderCell: ({ row }) => (row.data.lease_sub_status
                    ),
                    disableExport: false,
                    headerClassName: 'hide',
                    cellClassName: 'hide',
                    width: 200
                }
                // eslint-disable-next-line react-hooks/exhaustive-deps
            ]
         }

    }, [documents]);

    const tableWidth = columns.reduce((acc, col) => acc += col.width, 0);

    if (isLoading || isLoadingBuildingOccupancy) {

        return <Dimmer message='Fetching report, this can take up to 60 seconds' />;
    }
    const parsePrettyNumber = number => number.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: true
    });

    const calculateTotalDelinquentForProperty = delinquencies => delinquencies.reduce((acc, report) => {
        acc += report.total_delinquent;

        return acc;
    }, 0);

    const calculateTotalDelinquentForEvictions = delinquencies => delinquencies.reduce((acc, report) => {

        if (/eviction/i.test(report.lease_status)) {
            acc += report.total_delinquent;
        }

        return acc;
    }, 0);

    const calculateCounts = delinquencies => delinquencies.reduce((acc, unit) => {

        let balanceOver750 = false;

        if (unit.total_delinquent > 1000) {
            balanceOver750 = true;
            acc.total_delinquent++;
            if (unit.data.special_status !== 'Exception'){
                acc.fulls++;
            }
        }

        if (!!unit.data.initial_payment || !!unit.data.balance || !!unit.data.stipulation_signed_date || unit.active_repayment_agreement !== "No") {

            if (balanceOver750 === true) {
                acc.fulls--;
            }

            acc.stipulation++;
        }
        else if (/eviction/i.test(unit.lease_status)) {

            if (balanceOver750 === true) {
                acc.fulls--;
            }

            acc.eviction++;
        }

        if (unit.data.special_status === 'Adjustment') {
            acc.adjustment++;
        }
        else if (unit.data.special_status === 'Repayment Agreement') {
            acc.repayment_agreement++;
        }
        else if (unit.data.special_status === 'NSF') {
            acc.nsf++;
        }
        else if (unit.data.special_status === 'Section 8') {
            acc.section_8++;
        }
        else if (unit.data.special_status === 'Employee') {
            acc.employee++;
        }
        else if (unit.data.special_status === 'Govt. Assistance') {
            acc.govt_assistance++;
        }
        else if (unit.data.special_status === 'Exception') {
            acc.exception++;
        }

        return acc;
    }, {
        total_delinquent: 0,
        section_8: 0,
        nsf: 0,
        adjustment: 0,
        eviction: 0,
        stipulation: 0,
        fulls: 0,
        repayment_agreement: 0,
        employee: 0,
        govt_assistance: 0,
        exception: 0
    });

    const totalDelinquentForProperty = parsePrettyNumber(calculateTotalDelinquentForProperty(delinquencies));
    const totalDelinquentForExictions = parsePrettyNumber(calculateTotalDelinquentForEvictions(delinquencies));

    const counts = calculateCounts(delinquencies);

    let _className = 'print';

    if (adminOrLegal){
        _className = 'print landscape print-font-small reduce';
    }

    return (
        <div style={{ width: '100%' }} className={_className}>

            <Grid className={classes.legendContainer} container justifyContent='space-between'>
                <Grid item>
                    <Typography gutterBottom variant='h4' children={`${property?.name} Delinquencies`} />
                    <DelinquencyLegend
                        totalDelinquentForProperty={totalDelinquentForProperty}
                        totalDelinquentForExictions={totalDelinquentForExictions}
                    />
                </Grid>
                <Grid item>
                    <ColorLegend counts={counts} dataBuildingOccupancy={dataBuildingOccupancy} />
                </Grid>
            </Grid>

            <div >


                <DataGrid
                    style={{
                        width: tableWidth
                    }}
                    className={classes.dataGrid}
                    classes={{ row: classes.row }}
                    loading={isLoading}
                    columns={columns}
                    rows={delinquencies || []}
                    rowHeight={80}
                    getCellClassName={({ row, field }) => ColorRow(row, field)}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: () => (
                            <GridFooterContainer>
                                <GridFooter />
                            </GridFooterContainer>

                        )
                    }}
                    onCellClick={({ field, row }, event) => {
                        if (field === 'documents' || field === 'id') {
                            return;
                        }
                        setPopoverText(<DelinquencyPopoverContent row={row} role={props.role} />);
                        setAnchorEl(event.currentTarget);
                    }}
                    autoHeight
                    disableSelectionOnClick
                    hideFooterSelectedRowCount


                />
            </div>

            <Popover
                classes={{
                    paper: classes.padded
                }}
                open={open}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Typography>{popoverText}</Typography>
            </Popover>

        </div>
    );
};

const mapStateToProps = state => ({
    documents: Object.values(state.documents.data),
    role: state.auth.role,
    user_id: state.auth.id
});

export default connect(mapStateToProps, {
    fetchDocuments: documentActions.fetchDocuments,
    generateDocuments: documentActions.generateDocuments
})(ViewDelinquencies);


const ColorRow = (report, field) => {

    // console.log(report);
    // console.log('repoooort')

    const classes = useStyles();
    let style = classes.white;

    if (!['bldg_unit', 'resident_name', 'lease_status'].includes(field)) {
        return style;
    }

    if (report.total_delinquent > 1000) {
        style = classes.yellow;
    }
    if (report.data.special_status === 'NSF') {
        style = classes.green;
    }
    if (report.data.special_status === 'Section 8') {
        style = classes.purple;
    }
    if (report.data.special_status === 'Adjustment') {
        style = classes.blue;
    }

    // if (report.data.special_status === 'Repayment Agreement') {
    //     style = classes.lightGreen;
    // }

    if (report.data.special_status === 'Employee') {
        style = classes.lightBlue;
    }

    if (report.data.special_status === 'Govt. Assistance') {
        style = classes.orange;
    }

    if (/eviction/i.test(report.lease_status)) {
        style = classes.red;
    }

    if (!!report.data.initial_payment || !!report.data.balance || !!report.data.stipulation_signed_date || report.active_repayment_agreement !== "No") {
        style = classes.grey;
    }

    return style;
};

const formatDate = date => (date ? dayjs(date).format('MM/DD/YY').toString() : '');

export const defaultHeaders = [
    ['Documents'],
    ['Unit #', 'bldg_unit', true],
    ['Resident Name', 'resident_name', true],
    ['Lease Status', 'lease_status'],
    ['Total Delinquent', 'total_delinquent', true],
    // ['Payment Status', 'payment_status'],
    ['Scheduled Rent', 'scheduled_rent'],
    ['Manager Notes', 'data.manager_notes'],
    ['Hold Date', 'data.hold_date'],
    ['Held by', 'data.held_by']
];

export const legalHeaders = [
    ['Admin Notes', 'data.admin_notes'],
    ['General Notes', 'data.general_notes'],
    ['Court Registry', 'data.court_registry'],
    ['3day served', 'data.three_day_served'],
    ['File Date', 'data.file_date'],
    ['Case Number', 'data.case_number'],
    ['Summons Served', 'data.summons_served'],
    ['Default Date', 'data.default_date'],
    ['Motion to Strike', 'data.motion_to_strike'],
    ['Judgement', 'data.judgement'],
    ['Writ of Possession', 'data.writ_of_possession'],
    ['24-Hour notice', 'data.twentyfour_hour_notice']
];

